export function asArray(val) {
  return Array.isArray(val) ? val : []
}
